import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import {
  GET_MEMBERSHIPS_ANALYTICS_DETAILS,
  GET_MEMBERSHIPS_ANALYTICS_DETAILS_ERROR,
  GET_MEMBERSHIPS_ANALYTICS_DETAILS_SUCCESS,
} from '../../actions.js';

function* getGetMembershipsAnalyticsDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/membership-analytics`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_MEMBERSHIPS_ANALYTICS_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_MEMBERSHIPS_ANALYTICS_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_MEMBERSHIPS_ANALYTICS_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetMembershipsAnalyticsDetails() {
  yield takeEvery(GET_MEMBERSHIPS_ANALYTICS_DETAILS, getGetMembershipsAnalyticsDetails);
}

function* getMembershipsAnalyticsDetailsSaga() {
  yield all([fork(watchGetMembershipsAnalyticsDetails)]);
}

export default getMembershipsAnalyticsDetailsSaga;
